import React from 'react';

interface LoadingModalProps {
  showLoadingModal: boolean;
  loadingProgress: string;
  setShowLoadingModal: (show: boolean) => void;
  setIsBackgroundLoading: (loading: boolean) => void;
}

export const LoadingModal: React.FC<LoadingModalProps> = React.memo(({
  showLoadingModal,
  loadingProgress,
  setShowLoadingModal,
  setIsBackgroundLoading
}) => {
  if (!showLoadingModal) return null;

  return (
    <div className="fixed top-3 left-1/2 z-50 w-[min(92vw,48rem)] -translate-x-1/2">
      <div className="rounded-lg border border-slate-200 bg-white/95 px-3 py-2.5 shadow-xl backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 sm:px-4">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 h-4 w-4 flex-shrink-0 animate-spin rounded-full border-2 border-emerald-600 border-t-transparent dark:border-emerald-400" />
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-slate-800 dark:text-slate-200">
              Auto-reloading usage data...
            </p>
            {loadingProgress && (
              <p className="mt-0.5 truncate text-xs text-slate-600 dark:text-slate-400">
                {loadingProgress}
              </p>
            )}
          </div>
          <button
            onClick={() => {
              setShowLoadingModal(false);
              setIsBackgroundLoading(false);
            }}
            className="text-slate-400 transition-colors hover:text-slate-600 dark:hover:text-slate-200"
            title="Dismiss"
            aria-label="Dismiss auto reload notification"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
});
LoadingModal.displayName = 'LoadingModal';
